import {Suspense} from "react";
import {Route, Redirect} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {pathsBeforeLoginForPrivateRoutes, pathsValidForGestUsers, TOAST_ERROR, TOAST_WARN} from "../assets/constants/Constants";
import {GUESS_TOKEN, LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK, LS_LOCKER_BANK_INFO, USER_INFO} from "../assets/constants/BrowserStorageKeys";
import {isGuestUserAuthenticated} from "../lib/AuthUtils";
import {getSecureItemFromSpecificStorage} from "../lib/BrowserStorageAccessMiddleware";
import { getPathForNextPage, getUnitLabelParams } from "../lib/Utils";
import { ACCESS_LOCKER_BANK, LOGIN, QR_CODE_LANDING } from "../assets/constants/PageList";


export const ProtectedRoute = ({component: Component, ...rest}) => {
    const { t } = useTranslation();
    const domainAndLockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK);
    const areBothDomainAndLockerBankIdValid = ((domainAndLockerBankId?.domain) && (domainAndLockerBankId?.lockerBankId)) ? true : false;
    const userInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO);
    const isUserAuthenticated = isGuestUserAuthenticated(userInfo);
    const gestUser = getSecureItemFromSpecificStorage(LOCAL_STORAGE, GUESS_TOKEN);
    const isPathForProtectedRoute = pathsBeforeLoginForPrivateRoutes.includes(window.location.pathname);
    const isPathsForGestUsers = pathsValidForGestUsers.includes(window.location.pathname);
    const loginPath = getPathForNextPage(ACCESS_LOCKER_BANK, LOGIN);
    const isLoginPagePath = loginPath ? window.location.pathname === loginPath : false;
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);


    let message;
    let messageType;

    if (!areBothDomainAndLockerBankIdValid) {
        message = t('error_msg_could_not_understand_locker_bank_qr', unitLabelParams);
        messageType = TOAST_ERROR;
    }
    if (areBothDomainAndLockerBankIdValid && (!isUserAuthenticated)) {
        message = t('warning_msg_please_login_book_new_locker', unitLabelParams);
        messageType = TOAST_WARN;
    }
    return (
        <Route {...rest} render={(props) => {
            if (isUserAuthenticated && isLoginPagePath) {
                return <Suspense fallback={<></>} ><Component {...props} /></Suspense>
            }
            if ((areBothDomainAndLockerBankIdValid && (isUserAuthenticated || isPathForProtectedRoute)) || (gestUser && isPathsForGestUsers)) {
                return <Suspense fallback={<></>} ><Component {...props} /></Suspense>
            }
            else {
                return (
                    <Redirect
                        to={{
                            pathname: getPathForNextPage(QR_CODE_LANDING, ACCESS_LOCKER_BANK) || "/",
                            state: {
                                message: message,
                                messageType: messageType
                            }
                        }}
                    />
                );
            }
        }}
        />
    );
};
